import React from 'react';
import { useTheme } from 'styled-components';

const TextTicon = ({color, disabled=false}) => {
  const theme = useTheme();
  const stroke = color || (theme?.dark ? '#F5E7B1' : '#292D32');
  const tile = disabled
    ? theme.inputBorder
    : theme?.dark
      ? '#6A5428'
      : theme.tagLightYellow;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill={tile} />
      <path
        d="M10.0002 18.6666H14.0002C17.3335 18.6666 18.6668 17.3333 18.6668 13.9999V9.99992C18.6668 6.66659 17.3335 5.33325 14.0002 5.33325H10.0002C6.66683 5.33325 5.3335 6.66659 5.3335 9.99992V13.9999C5.3335 17.3333 6.66683 18.6666 10.0002 18.6666Z"
        stroke={disabled ? theme.borderColor : stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.6665 9.92563C10.7665 8.87896 13.2332 8.87896 15.3332 9.92563"
         stroke={disabled ? theme.borderColor : stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.8664V9.28638"
         stroke={disabled ? theme.borderColor : stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TextTicon;
